import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

// ── Shared bits (mirror the live app) ─────────────────────────────────────────
export function LiveTag() {
  return (
    <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-accent-wash px-2 py-[2px]">
      <span className="h-[5px] w-[5px] animate-h2h-pulse rounded-full bg-accent" />
      <span className="text-[9.5px] font-extrabold tracking-wide text-accent-ink">LIVE</span>
    </span>
  );
}

export function SoonTag() {
  return (
    <span className="shrink-0 rounded-full bg-[rgba(225,160,40,0.14)] px-2 py-[2px] text-[9.5px] font-extrabold tracking-wide text-[#9A6B12]">
      SOON
    </span>
  );
}

/** White content card the light illustrations sit on (matches the lobby cards). */
export function ListCard({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-[22px] border border-black/[0.07] bg-white p-[13px] shadow-[0_18px_40px_-26px_rgba(20,20,50,0.45)]">
      {children}
    </div>
  );
}

export function CardHeader({ label, trailing }: { label: string; trailing?: ReactNode }) {
  return (
    <div className="mb-[10px] flex items-center justify-between px-[3px]">
      <span className="text-[11px] font-extrabold uppercase tracking-eyebrow text-ink2">{label}</span>
      {trailing}
    </div>
  );
}

export function CoverageRow({
  emblem,
  name,
  sub,
  live,
  trailing,
  className
}: {
  emblem: ReactNode;
  name: string;
  sub: string;
  live?: boolean;
  trailing?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-[11px] rounded-[14px] border p-[8px_11px]',
        live ? 'border-accent/45 bg-[#F0FBF5]' : 'border-black/[0.06] bg-white',
        className
      )}
    >
      {emblem}
      <div className="min-w-0 flex-1">
        <div className="truncate text-[13.5px] font-bold tracking-snug text-ink">{name}</div>
        <div
          className={cn(
            'mt-px flex items-center gap-[5px] truncate text-[11px] font-semibold',
            live ? 'text-accent-ink' : 'text-ink2'
          )}
        >
          {live && <span className="h-[5px] w-[5px] animate-h2h-pulse rounded-full bg-accent" />}
          {sub}
        </div>
      </div>
      {trailing}
    </div>
  );
}
